var __create = Object.create;
var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties,
  __getOwnPropDesc = Object.getOwnPropertyDescriptor,
  __getOwnPropDescs = Object.getOwnPropertyDescriptors,
  __getOwnPropNames = Object.getOwnPropertyNames,
  __getOwnPropSymbols = Object.getOwnPropertySymbols,
  __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from[key],
    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_cjs = __commonJS({
  "../../../../node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";

    var isMergeableObject = function (value) {
      return isNonNullObject(value) && !isSpecial(value);
    };
    function isNonNullObject(value) {
      return !!value && typeof value == "object";
    }
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    var canUseSymbol = typeof Symbol == "function" && Symbol.for,
      REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== !1 && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
    }
    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function (element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }
    function getMergeFunction(key, options) {
      if (!options.customMerge) return deepmerge;
      var customMerge = options.customMerge(key);
      return typeof customMerge == "function" ? customMerge : deepmerge;
    }
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
        return target.propertyIsEnumerable(symbol);
      }) : [];
    }
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_) {
        return !1;
      }
    }
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    function mergeObject(target, source, options) {
      var destination = {};
      return options.isMergeableObject(target) && getKeys(target).forEach(function (key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
      }), getKeys(source).forEach(function (key) {
        propertyIsUnsafe(target, key) || (propertyIsOnObject(target, key) && options.isMergeableObject(source[key]) ? destination[key] = getMergeFunction(key, options)(target[key], source[key], options) : destination[key] = cloneUnlessOtherwiseSpecified(source[key], options));
      }), destination;
    }
    function deepmerge(target, source, options) {
      options = options || {}, options.arrayMerge = options.arrayMerge || defaultArrayMerge, options.isMergeableObject = options.isMergeableObject || isMergeableObject, options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source),
        targetIsArray = Array.isArray(target),
        sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      return sourceAndTargetTypesMatch ? sourceIsArray ? options.arrayMerge(target, source, options) : mergeObject(target, source, options) : cloneUnlessOtherwiseSpecified(source, options);
    }
    deepmerge.all = function (array, options) {
      if (!Array.isArray(array)) throw new Error("first argument should be an array");
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, options);
      }, {});
    };
    var deepmerge_1 = deepmerge;
    module.exports = deepmerge_1;
  }
});
import * as React13 from "react";
import { Box as Box13 } from "@twilio-paste/box";
import { Spinner } from "@twilio-paste/spinner";
import { secureExternalLink } from "@twilio-paste/anchor";
import { useSpring, animated } from "@twilio-paste/animation-library";
import { ArrowForwardIcon } from "@twilio-paste/icons/esm/ArrowForwardIcon";
import { LinkExternalIcon } from "@twilio-paste/icons/esm/LinkExternalIcon";
import PropTypes from "prop-types";
var DirectButtonPropTypes = {
    as: PropTypes.string,
    fullWidth: PropTypes.bool,
    href: PropTypes.string,
    size: PropTypes.oneOf(["small", "default", "icon", "icon_small", "reset", "rounded_small"]).isRequired,
    tabIndex: PropTypes.oneOf([0, -1]),
    type: PropTypes.oneOf(["submit", "button", "reset"]),
    disabled: PropTypes.bool,
    buttonState: PropTypes.oneOf(["disabled", "loading", "default"]).isRequired,
    variant: PropTypes.oneOf(["primary", "secondary", "destructive", "destructive_link", "destructive_secondary", "link", "inverse_link", "inverse", "reset", "primary_icon", "secondary_icon", "destructive_icon"])
  },
  ButtonPropTypes = {
    as: PropTypes.string,
    element: PropTypes.string,
    fullWidth: PropTypes.bool,
    href: PropTypes.string,
    size: PropTypes.oneOf(["small", "default", "icon", "icon_small", "reset", "rounded_small", "circle", "circle_small"]),
    tabIndex: PropTypes.oneOf([0, -1]),
    type: PropTypes.oneOf(["submit", "button", "reset"]),
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    variant: PropTypes.oneOf(["primary", "secondary", "destructive", "destructive_link", "destructive_secondary", "link", "inverse_link", "inverse", "reset", "primary_icon", "secondary_icon", "destructive_icon"]).isRequired,
    i18nExternalLinkLabel: PropTypes.string
  };
var import_deepmerge2 = __toESM(require_cjs());
import * as React from "react";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
var import_deepmerge = __toESM(require_cjs()),
  ResetStyles = {
    appearance: "none",
    background: "none",
    display: "inline-block",
    border: "none",
    outline: "none",
    transition: "background-color 100ms ease-in, box-shadow 100ms ease-in, color 100ms ease-in",
    fontFamily: "inherit",
    fontWeight: "fontWeightSemibold",
    textDecoration: "none",
    position: "relative",
    margin: "space0",
    _hover: {
      textDecoration: "none"
    },
    _focus: {
      textDecoration: "none",
      boxShadow: "shadowFocus"
    },
    _active: {
      textDecoration: "none"
    }
  },
  BaseStyles = {
    default: (0, import_deepmerge.default)(ResetStyles, {
      cursor: "pointer",
      _active: {
        boxShadow: "none"
      }
    }),
    disabled: (0, import_deepmerge.default)(ResetStyles, {
      cursor: "not-allowed"
    }),
    loading: (0, import_deepmerge.default)(ResetStyles, {
      cursor: "wait"
    })
  },
  SizeStyles = {
    default: {
      paddingTop: "space30",
      paddingBottom: "space30",
      paddingLeft: "space40",
      paddingRight: "space40",
      borderRadius: "borderRadius20",
      fontSize: "fontSize30",
      lineHeight: "lineHeight20"
    },
    small: {
      paddingTop: "space20",
      paddingBottom: "space20",
      paddingLeft: "space30",
      paddingRight: "space30",
      borderRadius: "borderRadius10",
      fontSize: "fontSize30",
      lineHeight: "lineHeight20"
    },
    icon: {
      padding: "space30",
      borderRadius: "borderRadius20"
    },
    icon_small: {
      padding: "space20",
      borderRadius: "borderRadius20"
    },
    reset: {
      paddingTop: "space0",
      paddingRight: "space0",
      paddingBottom: "space0",
      paddingLeft: "space0",
      borderWidth: "borderWidth0",
      fontSize: "inherit"
    },
    rounded_small: {
      borderRadius: "borderRadiusPill",
      paddingTop: "space20",
      paddingBottom: "space20",
      paddingLeft: "space30",
      paddingRight: "space30",
      fontSize: "fontSize30",
      lineHeight: "lineHeight20"
    },
    circle: {
      padding: "space30",
      borderRadius: "borderRadiusCircle"
    },
    circle_small: {
      padding: "space20",
      borderRadius: "borderRadiusCircle"
    }
  },
  ToggleStyles = {
    transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in",
    _pressed: {
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextWeakest",
      boxShadow: "shadowBorderPrimaryStronger"
    },
    _pressed_hover: {
      backgroundColor: "colorBackgroundPrimary",
      boxShadow: "shadowBorderPrimary",
      color: "colorTextInverse"
    },
    _pressed_focus: {
      boxShadow: "shadowFocusShadowBorder",
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextWeakest"
    }
  },
  ToggleIconButtonStyles = {
    transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in",
    _pressed: {
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextWeakest",
      boxShadow: "shadowBorderPrimaryStronger"
    },
    _pressed_hover: {
      backgroundColor: "colorBackgroundPrimary",
      boxShadow: "shadowBorderPrimary",
      color: "colorTextInverse"
    },
    _pressed_focus: {
      boxShadow: "shadowFocus",
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextWeakest"
    }
  };
var defaultStyles = (0, import_deepmerge2.default)(BaseStyles.default, {
    color: "colorTextInverse",
    backgroundColor: "colorBackgroundPrimary",
    boxShadow: "shadowBorderPrimary",
    _hover: {
      color: "colorTextWeakest",
      backgroundColor: "colorBackgroundPrimaryStronger",
      boxShadow: "shadowBorderPrimaryStronger"
    },
    _focus: {
      color: "colorTextWeakest",
      backgroundColor: "colorBackgroundPrimaryStronger",
      boxShadow: "shadowFocus"
    },
    _active: {
      color: "colorTextWeakest",
      backgroundColor: "colorBackgroundPrimaryStrongest",
      boxShadow: "shadowBorderPrimaryStrongest"
    }
  }),
  loadingStyles = (0, import_deepmerge2.default)(BaseStyles.loading, {
    color: "colorTextWeakest",
    backgroundColor: "colorBackgroundPrimaryStronger",
    boxShadow: "shadowBorderPrimaryStronger"
  }),
  disabledStyles = (0, import_deepmerge2.default)(BaseStyles.disabled, {
    color: "colorTextWeakest",
    backgroundColor: "colorBackgroundPrimaryWeak",
    boxShadow: "shadowBorderPrimaryWeak"
  }),
  ButtonStyleMapping = {
    default: defaultStyles,
    loading: loadingStyles,
    disabled: disabledStyles
  },
  PrimaryButton = React.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React.createElement(Box, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps(props)), ButtonStyleMapping[buttonState]), SizeStyles[size]));
  });
PrimaryButton.defaultProps = {
  as: "button"
};
PrimaryButton.displayName = "PrimaryButton";
var import_deepmerge3 = __toESM(require_cjs());
import * as React2 from "react";
import { Box as Box2, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
var defaultStyles2 = (0, import_deepmerge3.default)(BaseStyles.default, {
    color: "colorTextLink",
    _hover: {
      color: "colorTextLinkStronger"
    },
    _focus: {
      color: "colorTextLinkStronger"
    },
    _active: {
      color: "colorTextLinkStrongest"
    }
  }),
  loadingStyles2 = (0, import_deepmerge3.default)(BaseStyles.loading, {
    color: "colorTextLinkStronger"
  }),
  disabledStyles2 = (0, import_deepmerge3.default)(BaseStyles.disabled, {
    color: "colorTextLinkWeak"
  }),
  ButtonStyleMapping2 = {
    default: defaultStyles2,
    loading: loadingStyles2,
    disabled: disabledStyles2
  },
  PrimaryIconButton = React2.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React2.createElement(Box2, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps2(props)), ButtonStyleMapping2[buttonState]), SizeStyles[size]));
  });
PrimaryIconButton.defaultProps = {
  as: "button"
};
PrimaryIconButton.displayName = "PrimaryIconButton";
var import_deepmerge4 = __toESM(require_cjs());
import * as React3 from "react";
import { Box as Box3, safelySpreadBoxProps as safelySpreadBoxProps3 } from "@twilio-paste/box";
var defaultStyles3 = (0, import_deepmerge4.default)(BaseStyles.default, {
    color: "colorText",
    backgroundColor: "colorBackgroundBody",
    boxShadow: "shadowBorder",
    _hover: {
      color: "colorTextLinkStronger",
      backgroundColor: "colorBackgroundPrimaryWeakest",
      boxShadow: "shadowBorderPrimaryStronger"
    },
    _focus: {
      color: "colorTextLinkStronger",
      backgroundColor: "colorBackgroundPrimaryWeakest",
      boxShadow: "shadowFocusShadowBorder"
    },
    _active: {
      color: "colorTextLinkStronger",
      backgroundColor: "colorBackgroundPrimaryWeaker",
      boxShadow: "shadowBorderPrimaryStronger"
    }
  }),
  baseLoadingStyles = {
    color: "colorTextLinkStronger",
    backgroundColor: "colorBackgroundPrimaryWeaker",
    boxShadow: "shadowBorderPrimaryWeaker"
  },
  loadingStyles3 = (0, import_deepmerge4.default)(BaseStyles.loading, __spreadProps(__spreadValues({}, baseLoadingStyles), {
    _hover: baseLoadingStyles,
    _active: baseLoadingStyles,
    _focus: baseLoadingStyles
  })),
  baseDisabledStyles = {
    color: "colorTextWeaker",
    backgroundColor: "colorBackgroundBody",
    boxShadow: "shadowBorderWeak"
  },
  disabledStyles3 = (0, import_deepmerge4.default)(BaseStyles.disabled, __spreadProps(__spreadValues({}, baseDisabledStyles), {
    _hover: baseDisabledStyles,
    _active: baseDisabledStyles,
    _focus: baseDisabledStyles,
    _pressed: {
      backgroundColor: "colorBackgroundStrong",
      color: "colorTextWeak",
      boxShadow: "none"
    },
    _pressed_hover: {
      backgroundColor: "colorBackgroundStrong",
      color: "colorTextWeak",
      boxShadow: "none"
    }
  })),
  ButtonStyleMapping3 = {
    default: defaultStyles3,
    loading: loadingStyles3,
    disabled: disabledStyles3
  },
  SecondaryButton = React3.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth,
        pressed
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth", "pressed"]);
    let toggleStyles = pressed === void 0 ? {} : ToggleStyles;
    return React3.createElement(Box3, __spreadValues(__spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto",
      "aria-pressed": pressed
    }, safelySpreadBoxProps3(props)), toggleStyles), ButtonStyleMapping3[buttonState]), SizeStyles[size]));
  });
SecondaryButton.defaultProps = {
  as: "button"
};
SecondaryButton.displayName = "SecondaryButton";
var import_deepmerge5 = __toESM(require_cjs());
import * as React4 from "react";
import { Box as Box4, safelySpreadBoxProps as safelySpreadBoxProps4 } from "@twilio-paste/box";
var defaultStyles4 = (0, import_deepmerge5.default)(BaseStyles.default, {
    color: "colorTextIcon",
    _hover: {
      color: "colorText"
    },
    _focus: {
      color: "colorText"
    },
    _active: {
      color: "colorText"
    }
  }),
  loadingStyles4 = (0, import_deepmerge5.default)(BaseStyles.loading, {
    color: "colorText"
  }),
  disabledStyles4 = (0, import_deepmerge5.default)(BaseStyles.disabled, {
    color: "colorTextWeaker",
    _pressed: {
      backgroundColor: "colorBackgroundStrong",
      color: "colorTextWeak"
    },
    _pressed_hover: {
      backgroundColor: "colorBackgroundStrong",
      color: "colorTextWeak"
    }
  }),
  ButtonStyleMapping4 = {
    default: defaultStyles4,
    loading: loadingStyles4,
    disabled: disabledStyles4
  },
  SecondaryIconButton = React4.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth,
        pressed
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth", "pressed"]);
    let toggleStyles = pressed === void 0 ? {} : ToggleIconButtonStyles;
    return React4.createElement(Box4, __spreadValues(__spreadValues(__spreadValues(__spreadValues({
      ref,
      "aria-pressed": pressed,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps4(props)), toggleStyles), ButtonStyleMapping4[buttonState]), SizeStyles[size]));
  });
SecondaryIconButton.defaultProps = {
  as: "button"
};
SecondaryIconButton.displayName = "SecondaryIconButton";
var import_deepmerge6 = __toESM(require_cjs());
import * as React5 from "react";
import { Box as Box5, safelySpreadBoxProps as safelySpreadBoxProps5 } from "@twilio-paste/box";
var defaultStyles5 = (0, import_deepmerge6.default)(BaseStyles.default, {
    color: "colorTextInverse",
    backgroundColor: "colorBackgroundDestructive",
    boxShadow: "shadowBorderDestructive",
    _hover: {
      color: "colorTextWeakest",
      backgroundColor: "colorBackgroundDestructiveStronger",
      boxShadow: "shadowBorderDestructiveStronger"
    },
    _focus: {
      color: "colorTextWeakest",
      backgroundColor: "colorBackgroundDestructiveStronger",
      boxShadow: "shadowFocus"
    },
    _active: {
      color: "colorTextWeakest",
      backgroundColor: "colorBackgroundDestructiveStrongest",
      boxShadow: "shadowBorderDestructiveStrongest"
    }
  }),
  loadingStyles5 = (0, import_deepmerge6.default)(BaseStyles.loading, {
    color: "colorTextWeakest",
    backgroundColor: "colorBackgroundDestructiveStronger",
    boxShadow: "shadowBorderDestructiveStronger"
  }),
  disabledStyles5 = (0, import_deepmerge6.default)(BaseStyles.disabled, {
    color: "colorTextWeakest",
    backgroundColor: "colorBackgroundDestructiveWeak",
    boxShadow: "shadowBorderDestructiveWeak"
  }),
  ButtonStyleMapping5 = {
    default: defaultStyles5,
    loading: loadingStyles5,
    disabled: disabledStyles5
  },
  DestructiveButton = React5.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React5.createElement(Box5, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps5(props)), ButtonStyleMapping5[buttonState]), SizeStyles[size]));
  });
DestructiveButton.defaultProps = {
  as: "button"
};
DestructiveButton.displayName = "DestructiveButton";
var import_deepmerge7 = __toESM(require_cjs());
import * as React6 from "react";
import { Box as Box6, safelySpreadBoxProps as safelySpreadBoxProps6 } from "@twilio-paste/box";
var defaultStyles6 = (0, import_deepmerge7.default)(BaseStyles.default, {
    color: "colorTextLinkDestructive",
    _hover: {
      color: "colorTextLinkDestructiveStronger"
    },
    _focus: {
      color: "colorTextLinkDestructiveStronger"
    },
    _active: {
      color: "colorTextLinkDestructiveStrongest"
    }
  }),
  loadingStyles6 = (0, import_deepmerge7.default)(BaseStyles.loading, {
    color: "colorTextLinkDestructiveStronger"
  }),
  disabledStyles6 = (0, import_deepmerge7.default)(BaseStyles.disabled, {
    color: "colorTextLinkDestructiveWeak"
  }),
  ButtonStyleMapping6 = {
    default: defaultStyles6,
    loading: loadingStyles6,
    disabled: disabledStyles6
  },
  DestructiveIconButton = React6.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React6.createElement(Box6, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps6(props)), ButtonStyleMapping6[buttonState]), SizeStyles[size]));
  });
DestructiveIconButton.defaultProps = {
  as: "button"
};
DestructiveIconButton.displayName = "DestructiveIconButton";
var import_deepmerge8 = __toESM(require_cjs());
import * as React7 from "react";
import { Box as Box7, safelySpreadBoxProps as safelySpreadBoxProps7 } from "@twilio-paste/box";
var defaultStyles7 = (0, import_deepmerge8.default)(BaseStyles.default, {
    color: "colorTextLinkDestructive",
    textAlign: "left",
    transition: "none",
    _hover: {
      color: "colorTextLinkDestructiveStronger",
      textDecoration: "underline"
    },
    _active: {
      color: "colorTextLinkDestructiveStrongest",
      textDecoration: "underline"
    },
    _focus: {
      color: "colorTextLinkDestructiveStronger",
      textDecoration: "underline"
    }
  }),
  loadingStyles7 = (0, import_deepmerge8.default)(BaseStyles.loading, {
    color: "colorTextLinkDestructiveStronger",
    textAlign: "left",
    _hover: {
      color: "colorTextLinkDestructiveStronger"
    },
    _active: {
      color: "colorTextLinkDestructiveStronger"
    },
    _focus: {
      color: "colorTextLinkDestructiveStronger"
    }
  }),
  disabledStyles7 = (0, import_deepmerge8.default)(BaseStyles.disabled, {
    color: "colorTextLinkDestructiveWeak",
    textAlign: "left",
    _hover: {
      color: "colorTextLinkDestructiveWeak"
    },
    _active: {
      color: "colorTextLinkDestructiveWeak"
    },
    _focus: {
      color: "colorTextLinkDestructiveWeak"
    }
  }),
  ButtonStyleMapping7 = {
    default: defaultStyles7,
    loading: loadingStyles7,
    disabled: disabledStyles7
  },
  DestructiveLinkButton = React7.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React7.createElement(Box7, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps7(props)), ButtonStyleMapping7[buttonState]), SizeStyles[size]));
  });
DestructiveLinkButton.defaultProps = {
  as: "a"
};
DestructiveLinkButton.displayName = "DestructiveLinkButton";
var import_deepmerge9 = __toESM(require_cjs());
import * as React8 from "react";
import { Box as Box8, safelySpreadBoxProps as safelySpreadBoxProps8 } from "@twilio-paste/box";
var defaultStyles8 = (0, import_deepmerge9.default)(BaseStyles.default, {
    color: "colorTextLinkDestructive",
    backgroundColor: "colorBackgroundBody",
    boxShadow: "shadowBorderDestructive",
    _hover: {
      color: "colorTextLinkDestructiveStronger",
      backgroundColor: "colorBackgroundDestructiveWeakest",
      boxShadow: "shadowBorderDestructiveStronger"
    },
    _focus: {
      color: "colorTextLinkDestructiveStronger",
      backgroundColor: "colorBackgroundDestructiveWeakest",
      boxShadow: "shadowFocus"
    },
    _active: {
      color: "colorTextLinkDestructiveStronger",
      backgroundColor: "colorBackgroundDestructiveWeaker",
      boxShadow: "shadowBorderDestructiveStronger"
    }
  }),
  baseLoadingStyles2 = {
    color: "colorTextLinkDestructiveStronger",
    backgroundColor: "colorBackgroundDestructiveWeaker",
    boxShadow: "shadowBorderDestructiveWeaker"
  },
  loadingStyles8 = (0, import_deepmerge9.default)(BaseStyles.loading, __spreadProps(__spreadValues({}, baseLoadingStyles2), {
    _hover: baseLoadingStyles2,
    _active: baseLoadingStyles2,
    _focus: baseLoadingStyles2
  })),
  baseDisabledStyles2 = {
    color: "colorTextLinkDestructiveWeak",
    backgroundColor: "colorBackgroundBody",
    boxShadow: "shadowBorderDestructiveWeak"
  },
  disabledStyles8 = (0, import_deepmerge9.default)(BaseStyles.disabled, __spreadProps(__spreadValues({}, baseDisabledStyles2), {
    _hover: baseDisabledStyles2,
    _active: baseDisabledStyles2,
    _focus: baseDisabledStyles2
  })),
  ButtonStyleMapping8 = {
    default: defaultStyles8,
    loading: loadingStyles8,
    disabled: disabledStyles8
  },
  DestructiveSecondaryButton = React8.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React8.createElement(Box8, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps8(props)), ButtonStyleMapping8[buttonState]), SizeStyles[size]));
  });
DestructiveSecondaryButton.defaultProps = {
  as: "button"
};
DestructiveSecondaryButton.displayName = "DestructiveSecondaryButton";
var import_deepmerge10 = __toESM(require_cjs());
import * as React9 from "react";
import { Box as Box9, safelySpreadBoxProps as safelySpreadBoxProps9 } from "@twilio-paste/box";
var defaultStyles9 = (0, import_deepmerge10.default)(BaseStyles.default, {
    color: "colorTextLink",
    textAlign: "left",
    transition: "none",
    _hover: {
      color: "colorTextLinkStronger",
      textDecoration: "underline"
    },
    _focus: {
      color: "colorTextLinkStronger",
      textDecoration: "underline"
    },
    _active: {
      color: "colorTextLinkStrongest",
      textDecoration: "underline"
    }
  }),
  loadingStyles9 = (0, import_deepmerge10.default)(BaseStyles.loading, {
    color: "colorTextLinkStronger",
    textAlign: "left"
  }),
  disabledStyles9 = (0, import_deepmerge10.default)(BaseStyles.disabled, {
    color: "colorTextLinkWeak",
    textAlign: "left"
  }),
  ButtonStyleMapping9 = {
    default: defaultStyles9,
    loading: loadingStyles9,
    disabled: disabledStyles9
  },
  LinkButton = React9.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React9.createElement(Box9, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps9(props)), ButtonStyleMapping9[buttonState]), SizeStyles[size]));
  });
LinkButton.defaultProps = {
  as: "a"
};
LinkButton.displayName = "LinkButton";
var import_deepmerge11 = __toESM(require_cjs());
import * as React10 from "react";
import { Box as Box10, safelySpreadBoxProps as safelySpreadBoxProps10 } from "@twilio-paste/box";
var defaultStyles10 = (0, import_deepmerge11.default)(BaseStyles.default, {
    color: "colorTextInverse",
    fontWeight: "fontWeightSemibold",
    backgroundColor: "colorBackgroundInverse",
    boxShadow: "shadowBorderInverse",
    _hover: {
      color: "colorTextInverse",
      fontWeight: "fontWeightSemibold",
      backgroundColor: "colorBackgroundInverseStrong",
      boxShadow: "shadowBorderInverseStrongest"
    },
    _focus: {
      color: "colorTextInverse",
      fontWeight: "fontWeightSemibold",
      backgroundColor: "colorBackgroundInverseStrong",
      boxShadow: "shadowFocusInverse"
    },
    _active: {
      color: "colorTextInverse",
      fontWeight: "fontWeightSemibold",
      backgroundColor: "colorBackgroundInverseStrong",
      boxShadow: "shadowBorderInverseStrongest"
    }
  }),
  loadingStyles10 = (0, import_deepmerge11.default)(BaseStyles.loading, {
    color: "colorTextInverse",
    fontWeight: "fontWeightSemibold",
    backgroundColor: "colorBackgroundInverseStrong",
    boxShadow: "shadowBorderInverseWeaker"
  }),
  disabledStyles10 = (0, import_deepmerge11.default)(BaseStyles.disabled, {
    color: "colorTextInverseWeaker",
    fontWeight: "fontWeightSemibold",
    backgroundColor: "colorBackgroundInverse",
    boxShadow: "shadowBorderInverseWeakest"
  }),
  ButtonStyleMapping10 = {
    default: defaultStyles10,
    loading: loadingStyles10,
    disabled: disabledStyles10
  },
  InverseButton = React10.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React10.createElement(Box10, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps10(props)), ButtonStyleMapping10[buttonState]), SizeStyles[size]));
  });
InverseButton.defaultProps = {
  as: "button"
};
InverseButton.displayName = "InverseButton";
var import_deepmerge12 = __toESM(require_cjs());
import * as React11 from "react";
import { Box as Box11, safelySpreadBoxProps as safelySpreadBoxProps11 } from "@twilio-paste/box";
var defaultStyles11 = (0, import_deepmerge12.default)(BaseStyles.default, {
    color: "colorTextInverse",
    textAlign: "left",
    transition: "none",
    _hover: {
      color: "colorTextInverseWeaker",
      textDecoration: "underline"
    },
    _focus: {
      color: "colorTextInverseWeaker",
      boxShadow: "shadowFocusInverse",
      textDecoration: "underline"
    },
    _active: {
      textDecoration: "underline"
    }
  }),
  loadingStyles11 = (0, import_deepmerge12.default)(BaseStyles.loading, {
    color: "colorTextInverse",
    textAlign: "left"
  }),
  disabledStyles11 = (0, import_deepmerge12.default)(BaseStyles.disabled, {
    color: "colorTextInverseWeaker",
    textAlign: "left"
  }),
  ButtonStyleMapping11 = {
    default: defaultStyles11,
    loading: loadingStyles11,
    disabled: disabledStyles11
  },
  InverseLinkButton = React11.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React11.createElement(Box11, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps11(props)), ButtonStyleMapping11[buttonState]), SizeStyles[size]));
  });
InverseLinkButton.defaultProps = {
  as: "a"
};
InverseLinkButton.displayName = "InverseLinkButton";
var import_deepmerge13 = __toESM(require_cjs());
import * as React12 from "react";
import { Box as Box12, safelySpreadBoxProps as safelySpreadBoxProps12 } from "@twilio-paste/box";
var defaultStyles12 = (0, import_deepmerge13.default)(BaseStyles.default, {
    fontWeight: "inherit",
    color: "inherit"
  }),
  loadingStyles12 = (0, import_deepmerge13.default)(BaseStyles.loading, {
    fontSize: "inherit",
    fontWeight: "inherit"
  }),
  disabledStyles12 = (0, import_deepmerge13.default)(BaseStyles.disabled, {
    fontSize: "inherit",
    fontWeight: "inherit"
  }),
  ButtonStyleMapping12 = {
    default: defaultStyles12,
    loading: loadingStyles12,
    disabled: disabledStyles12
  },
  ResetButton = React12.forwardRef((_a, ref) => {
    var _b = _a,
      {
        size,
        buttonState,
        fullWidth
      } = _b,
      props = __objRest(_b, ["size", "buttonState", "fullWidth"]);
    return React12.createElement(Box12, __spreadValues(__spreadValues(__spreadValues({
      ref,
      width: fullWidth ? "100%" : "auto"
    }, safelySpreadBoxProps12(props)), ButtonStyleMapping12[buttonState]), SizeStyles[size]));
  });
ResetButton.defaultProps = {
  as: "button"
};
ResetButton.displayName = "ResetButton";
var AnimatedBox = animated(Box13),
  getButtonSize = (variant, children, size) => {
    let smartSize = "default";
    return size != null ? smartSize = size : variant === "link" || variant === "destructive_link" || variant === "reset" ? smartSize = "reset" : React13.Children.count(children) === 1 && React13.Children.forEach(children, child => {
      React13.isValidElement(child) && typeof child.type.displayName == "string" && child.type.displayName.includes("Icon") && (smartSize = "icon");
    }), smartSize;
  },
  getButtonState = (disabled, loading) => disabled ? "disabled" : loading ? "loading" : "default",
  handlePropValidation = _ref => {
    let {
      as,
      href,
      tabIndex,
      variant,
      size,
      fullWidth,
      children,
      disabled,
      loading,
      pressed
    } = _ref;
    let hasHref = href != null && href !== "",
      hasTabIndex = tabIndex != null;
    if (as !== "a" && hasHref) throw new Error("[Paste: Button] You cannot pass href into a button without the 'a' tag.  Use 'as=\"a\"'.");
    if (as === "a") {
      if (!hasHref) throw new Error("[Paste: Button] Missing href prop for link button.");
      if (variant === "link" || variant === "inverse_link") throw new Error("[Paste: Button] Using Button component as an Anchor. Use the Paste Anchor component instead.");
      if (variant !== "primary" && variant !== "secondary" && variant !== "reset" && variant !== "inverse") throw new Error('[Paste: Button] <Button as="a"> only works with the following variants: primary and secondary.');
      if (disabled || loading) throw new Error('[Paste: Button] <Button as="a"> cannot be disabled or loading.');
    }
    if (variant === "reset" && size !== "reset") throw new Error('[Paste: Button] The "RESET" variant can only be used with the "RESET" size.');
    if ((size === "icon" || size === "icon_small" || size === "circle" || size === "circle_small") && fullWidth) throw new Error("[Paste: Button] Icon buttons should not be fullWidth.");
    if (children == null) throw new Error("[Paste: Button] Must have non-null children.");
    if (hasTabIndex && !(tabIndex === 0 || tabIndex === -1)) throw new Error("[Paste: Button] tabIndex must be 0 or -1.");
    if (pressed && !(variant === "secondary" || variant === "secondary_icon")) throw new Error('[Paste: Button] pressed can only be used with "secondary" and "secondary_icon" variants.');
  },
  variantsWithoutBoundingBox = new Set(["link", "destructive_link", "inverse_link", "reset"]),
  ButtonContents = _ref2 => {
    let {
      buttonState,
      children,
      showLoading,
      variant
    } = _ref2;
    let buttonVariantHasBoundingBox = variant && variantsWithoutBoundingBox.has(variant);
    return React13.createElement(React13.Fragment, null, React13.createElement(Box13, {
      as: "span",
      display: "flex",
      textDecoration: "inherit",
      opacity: buttonState === "loading" ? "0" : "1",
      justifyContent: buttonVariantHasBoundingBox ? null : "center",
      columnGap: "space20",
      alignItems: "center"
    }, children), showLoading ? React13.createElement(Box13, {
      as: "span",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      lineHeight: "lineHeight30"
    }, React13.createElement(Spinner, {
      decorative: !0,
      delay: 0
    })) : null);
  };
ButtonContents.displayName = "ButtonContents";
var getButtonComponent = variant => {
    switch (variant) {
      case "primary_icon":
        return PrimaryIconButton;
      case "secondary":
        return SecondaryButton;
      case "secondary_icon":
        return SecondaryIconButton;
      case "destructive":
        return DestructiveButton;
      case "destructive_icon":
        return DestructiveIconButton;
      case "destructive_secondary":
        return DestructiveSecondaryButton;
      case "link":
        return LinkButton;
      case "destructive_link":
        return DestructiveLinkButton;
      case "reset":
        return ResetButton;
      case "inverse":
        return InverseButton;
      case "inverse_link":
        return InverseLinkButton;
      case "primary":
      default:
        return PrimaryButton;
    }
  },
  Button = React13.forwardRef((_a, ref) => {
    var _b = _a,
      {
        element = "BUTTON",
        i18nExternalLinkLabel = "(link takes you to an external page)"
      } = _b,
      props = __objRest(_b, ["element", "i18nExternalLinkLabel"]);
    let _a2 = props,
      {
        size,
        variant,
        children,
        disabled,
        loading
      } = _a2,
      rest = __objRest(_a2, ["size", "variant", "children", "disabled", "loading"]),
      [hovered, setHovered] = React13.useState(!1),
      arrowIconStyles = useSpring({
        translateX: hovered ? "4px" : "0px",
        config: {
          mass: .1,
          tension: 275,
          friction: 16
        }
      }),
      smartDefaultSize = React13.useMemo(() => getButtonSize(variant, children, size), [size, variant, children]);
    handlePropValidation(__spreadProps(__spreadValues({}, props), {
      size: smartDefaultSize
    }));
    let buttonState = getButtonState(disabled, loading),
      showLoading = buttonState === "loading",
      showDisabled = buttonState !== "default",
      ButtonComponent = getButtonComponent(variant),
      externalLinkProps = props.href != null ? secureExternalLink(props.href) : null,
      injectIconChildren = children;
    return props.as === "a" && props.href != null && typeof children == "string" && variant !== "reset" && (injectIconChildren = React13.createElement(React13.Fragment, null, children, externalLinkProps != null ? React13.createElement(LinkExternalIcon, {
      decorative: !1,
      title: i18nExternalLinkLabel
    }) : React13.createElement(AnimatedBox, {
      style: arrowIconStyles
    }, React13.createElement(ArrowForwardIcon, {
      decorative: !0
    })))), React13.createElement(ButtonComponent, __spreadProps(__spreadValues(__spreadValues({}, externalLinkProps), rest), {
      onMouseEnter: event => {
        typeof rest.onMouseEnter == "function" && rest.onMouseEnter(event), setHovered(!0);
      },
      onMouseLeave: event => {
        typeof rest.onMouseLeave == "function" && rest.onMouseLeave(event), setHovered(!1);
      },
      buttonState,
      disabled: showDisabled,
      element,
      variant,
      size: smartDefaultSize,
      "aria-busy": buttonState === "loading" ? "true" : "false",
      className: void 0,
      style: void 0,
      ref
    }), React13.createElement(ButtonContents, {
      buttonState,
      showLoading,
      variant
    }, injectIconChildren));
  });
Button.defaultProps = {
  as: "button",
  fullWidth: !1,
  disabled: !1,
  loading: !1,
  type: "button",
  variant: "primary"
};
Button.propTypes = ButtonPropTypes;
Button.displayName = "Button";
export { Button, ToggleStyles as ButtonToggleStyles };